import { InternalApiError } from './internal-api-client'

const FALLBACK_MESSAGE = 'Something went wrong, please try again.'

type ErrorEntry = string | { title?: string; detail?: string }

/**
 * Message to show when `POST /api/v1/skills/bulk_delete` fails.
 *
 * The server answers with JSON:API `errors` (`{ title, detail }`), and
 * `InternalApiError` would flatten those into "[object Object]", so read the
 * response body directly. Prefers the specific `detail` (e.g. "Could not delete
 * Ruby") over the generic `title`, and falls back to a generic message for
 * network errors or bodies without usable text.
 */
export const bulkDeleteError = (error: unknown): string => {
  if (!(error instanceof InternalApiError)) return FALLBACK_MESSAGE

  const errors = error.body?.['errors']
  if (!Array.isArray(errors)) return FALLBACK_MESSAGE

  const messages = (errors as ErrorEntry[])
    .map((entry) =>
      typeof entry === 'string' ? entry : entry?.detail || entry?.title,
    )
    .filter((message): message is string => !!message)

  return messages.length > 0 ? messages.join(' ') : FALLBACK_MESSAGE
}
